/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plancancelinsettings3Inputs */

const en_plancancelinsettings3 = /** @type {(inputs: Plancancelinsettings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel in settings`)
};

const de_plancancelinsettings3 = /** @type {(inputs: Plancancelinsettings3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In den Einstellungen kündigen`)
};

/**
* | output |
* | --- |
* | "Cancel in settings" |
*
* @param {Plancancelinsettings3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const plancancelinsettings3 = /** @type {((inputs?: Plancancelinsettings3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plancancelinsettings3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plancancelinsettings3(inputs)
	return de_plancancelinsettings3(inputs)
});
export { plancancelinsettings3 as "planCancelInSettings" }